import React, { FC, PropsWithChildren } from 'react'
import SALink from 'components/SALink'
import useQA from 'hooks/useQA'
import styles from '../Polaroid.module.scss'
import classNames from 'classnames'

type PolaroidTextLinkProps = {
  link: string
  onClick?: (ev: React.SyntheticEvent<Record<string, any>>) => void
  shouldOpenNewTab?: boolean
  dataTestId?: string
  linkDataTestId?: string
  customStyles?: string
  ariaLabel?: string
}

const PolaroidTextLink: FC<PropsWithChildren<PolaroidTextLinkProps>> = ({
  children,
  link,
  onClick,
  shouldOpenNewTab,
  dataTestId,
  linkDataTestId,
  ariaLabel,
  customStyles,
}) => {
  const { testId } = useQA()

  return (
    <h6
      className={classNames(styles.polaroidTextH6, customStyles)}
      {...(!!dataTestId ? testId(dataTestId) : {})}
    >
      <SALink
        href={link}
        onClick={onClick}
        className={styles.polaroidTextLinkElement}
        aria-label={ariaLabel}
        title={ariaLabel}
        rel='nofollow'
        target={shouldOpenNewTab ? '_blank' : ''}
        {...(!!linkDataTestId ? testId(linkDataTestId) : {})}
      >
        {children}
      </SALink>
    </h6>
  )
}

export default PolaroidTextLink
